const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the outstanding scores list directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('outstandingScoresList', ['AssessmentScores', function (AssessmentScores) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      assessment: '=',
      activeScore: '=',
      reset: '=',
      watch: '@'
    },
    template: require('../../../templates/directives/assessments/outstanding-scores-list.html'),
    controller: ['$scope', function ($scope) {
        var self = this;

        self.info = {
          assessmentScores: [],
          per_page: 15,
          loading: false,
          searching: false,
          query: {},
          selectionDirectory: {},
          onData: function(data) {
            self.navigation.noNext = false;
            if (!data || !data.length) {
              self.navigation.noNext = true;
              return;
            }
            self.info.assessmentScores = data;
            if (data.length < self.info.per_page) {
              self.navigation.noNext = true;
            }
          }
        };

        self.scoreItems = {
          show: false,
          active: null,
          onClick: function(item) {
            if (!item || !item._id) {
              return;
            }
            $scope.activeScore = item._id;
          }
        };

        var getStandardQuery = function(){
          return {
            subresource: '',
            fields: '_id,company,user,assessment,awaiting_manual_grade,createdAt',
            page: 1,
            per_page: self.info.per_page,
            awaiting_manual_grade: true,
            'user-populate': 'first_name,last_name,full_name,email,linked_departments,linked_locations',
            'user.linked_departments-populate': 'name',
            'user.linked_locations-populate': 'name',
            assessment: $scope.assessment && $scope.assessment._id
          };
        };
        self.info.query = getStandardQuery();

        self.initialize = function () {
          self.info.assessmentScores = [];
          self.info.per_page = 15;
          self.info.loading = false;
          self.info.searching = false;
          self.info.selectionDirectory = {};
          self.info.query = getStandardQuery();
          self.scoreItems.show = false;
          self.scoreItems.active = null;
          self.navigation.noNext = false;
          self.info.initialized = true;
          self.load();
        };

        self.load = function () {
          if (!$scope.assessment || !$scope.assessment._id) {
            // error for no assessment id
            return;
          }
          self.info.loading = true;
          AssessmentScores.find(self.info.query).$promise
          .then(function (assessmentScores) {
            self.info.onData(assessmentScores);
            self.info.loading = false;
          }).catch(function (error) {
            self.info.loading = false;
            console.log('Error getting user assessments:', error);
          });
        };

        self.navigation = {
          noNext: false,
          previous: function () {
            if (self.info.query.page === 1) {
              return;
            }
            self.info.query.page--;
            self.load();
          },
          next: function () {
            if (self.info.assessmentScores.length !== self.info.per_page || self.navigation.noNext) {
              return;
            }
            self.info.query.page++;
            self.load();
          }
        };

        if ($scope.assessment && $scope.assessment._id) {
          self.initialize();
        }

        if ($scope.watch) {
          $scope.$watch('assessment', function(newVal, oldVal) {
            if (!newVal || (newVal && !newVal._id)) {
              return;
            }
            if (!oldVal || !oldVal._id || (newVal._id !== oldVal._id)) {
              self.initialize();
            }
          }, true);
        }

        $scope.$watch('reset', function(newVal, oldVal) {
          if (newVal && !oldVal) {
            self.initialize();
            $scope.reset = false;
          }
        });

      }],
    controllerAs: 'scoreList'
  };
}]);